import React from 'react';

import { LiveKitRoomProps, LiveKitRoom as OriginalLiveKitRoom } from '@livekit/components-react';
import { config } from 'environment/config';
import { AudioPresets } from 'livekit-client';
// The original LiveKitRoom component returns a Reactnode which is not valid JSX in our version.
// This is why we create a wrapper component that returns a valid JSX.Element
type SafeReactComponent<P = unknown> = React.ComponentType<P> & {
  (props: P & { children?: React.ReactNode }): JSX.Element | null;
};

const LiveKitRoom = OriginalLiveKitRoom as SafeReactComponent<LiveKitRoomProps>;

interface LiveKitRoomWrapperProps {
  token: string;
  children: React.ReactNode;
}

export function LiveKitRoomWrapper({ token, children }: LiveKitRoomWrapperProps) {
  return (
    <LiveKitRoom
      serverUrl={config.livekitProjectUrl}
      token={token}
      connect
      audio={{
        echoCancellation: true,
        noiseSuppression: true
      }}
      options={{ publishDefaults: { audioPreset: AudioPresets.speech } }}>
      {children}
    </LiveKitRoom>
  );
}
